<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2124261" style="color: #82a339"><b>SPRING PEA SOUP</b></p>
<p class="ser"><img alt="9781618371621_0061_001" src="Images/9781618371621_0061_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e2112261">Spring Pea Soup</p>
<p class="ext" id="d7e2124761"><b><i>As bright and green as the season, this soup has a fresh flavor that complements any celebratory meal. If you can’t find edible flowers, garnish with pea shoots or a sprig of mint.</i></b></p>
<p class="h4" id="d7e2126361" style="color: #496210"><b>Prep: 12 minutes Cook: 23 minutes</b></p>
<p class="ul" id="d7e2126961">2 tablespoons butter or margarine</p>
<p class="ul" id="d7e2127261">2 large shallots, thinly sliced (¾ cup)</p>
<p class="ul" id="d7e2128361">1 carton (32 ounces) reduced-sodium chicken broth</p>
<p class="ul" id="d7e2128661">2 cups water</p>
<p class="ul" id="d7e2129061">2 bags (16 ounces each) frozen peas, thawed</p>
<p class="ul" id="d7e2129361">1 large all-purpose potato (8 ounces), peeled and cut <br/> into 1-inch chunks</p>
<p class="ul" id="d7e2129961">½ cup loosely packed fresh mint leaves, chopped</p>
<p class="ul" id="d7e2130961">¾ teaspoon salt</p>
<p class="ul" id="d7e2131861">¼ teaspoon ground black pepper</p>
<p class="ul" id="d7e2132861">3 tablespoons fresh lemon juice</p>
<p class="ul" id="d7e2133161">10 nasturtium flowers for garnish (optional, see Tip)</p>
<p class="pub" id="d7e2133661" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 4-quart saucepan, heat butter on medium-low until melted. Add shallots and cook 10 to 12 minutes or until very tender.</p>
<p class="pub" id="d7e2134961"><span style="color: #c15b49"><b>2.</b></span> Add broth, water, peas, potato, half of chopped mint, salt, and pepper; heat to boiling on high. Reduce heat to medium; simmer mixture 10 minutes, stirring occasionally.</p>
<p class="pub" id="d7e2136661"><span style="color: #c15b49"><b>3.</b></span> Spoon half of mixture into blender; cover, removing center part of lid to let steam escape. Lay a paper towel over top and puree until smooth. Pour puree into medium bowl. Repeat with remaining mixture. Return soup to saucepan, and reheat on medium if necessary. Stir in lemon juice and remaining mint.</p>
<p class="pub" id="d7e2139461"><span style="color: #c15b49"><b>4.</b></span> To serve, spoon soup into 10 serving bowls; garnish with nasturtiums if using. Makes 10 first-course servings.</p>
<p class="ntx" id="d7e2141161">Each serving: About 120 calories, 6g protein, 19g carbohydrate, 3g total fat (1g saturated), 5g fiber, 0mg cholesterol, 475mg sodium.</p>
<p class="pub" id="d7e2144161"><span style="color: #c15b49"><b>Tip:</b></span> Nasturtiums and other edible flowers can be found in the produce section of better supermarkets and at farmers’ markets.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c61_r1.vue?d12a7e66